import React from 'react';
import { PublicListDataSource } from '../../models/public-list';
import { publicListToolbarButtonFactory } from '../../composite/public-list-toolbar-button/public-list-toolbar-button';
import { RecipientsSource } from '../../models/mail-campaign';
import { mailingToolbarButtonFactory } from '../../composite/mailing-toolbar-button/mailing-toolbar-button';

const PublicListToolbarButton = publicListToolbarButtonFactory({
  dataSource: PublicListDataSource.OZO_M_EVIDENCE,
  name: 'Veřejný seznam výrobců kotlů',
});

const MailingToolbarButton = mailingToolbarButtonFactory({
  source: RecipientsSource.OZO_MANUFACTURER,
});

export function BoilerManufacturersTableToolbar() {
  return (
    <>
      <PublicListToolbarButton />
      <MailingToolbarButton />
    </>
  );
}
